/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles({
  dialogContentStyle: {
    scrollbarWidth: 0,
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: '0px',
      background: 'transparent',
    },
  },
  titleStyle: {
    textAlign: 'center',
  },
  buttonCategory: {
    margin: 0,
    borderRadius: 0,
    padding: 15,
    fontWeight: 'bold',
  },
});

function CategoryDialog(props) {
  const classes = useStyles();
  const {
    data, onClose, selectedValue, open,
  } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    selectedValue(value);
  };

  return (
    <Dialog maxWidth="xs" fullWidth onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle className={classes.titleStyle} id="simple-dialog-title">PILIH KATEGORI</DialogTitle>
      <DialogContent className={classes.dialogContentStyle}>
        <List>
          <ListItem button onClick={handleClose}>
            <ListItemText primary="SEMUA" />
          </ListItem>
          {data.map((category, index) => (
            <ListItem button onClick={() => handleListItemClick(category)} key={index}>
              <ListItemText primary={category} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
}

export default function OlsCategorySelect(props) {
  const classes = useStyles();
  const { data, onSelect } = props;
  const [open, setOpen] = React.useState(false);
  const [selectedCategory, setSelectedCategory] = React.useState('PILIH KATEGORI');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCategory('PILIH KATEGORI');
    onSelect('');
  };

  const handleSelect = (value) => {
    setOpen(false);
    if (value.length > 0) {
      setSelectedCategory(value);
      onSelect(value);
    } else {
      setSelectedCategory('PILIH KATEGORI');
      onSelect('');
    }
  };

  return (
    <div>
      <Button className={classes.buttonCategory} type="submit" fullWidth variant="contained" color="primary" onClick={handleClickOpen}>
        {selectedCategory}
      </Button>
      <CategoryDialog data={data} selectedValue={handleSelect} open={open} onClose={handleClose} />
    </div>
  );
}
